import { FC } from 'react'

import { Button } from './styled'

const ScrollDownButton: FC<{
  onClick: () => void
}> = ({ onClick }) => (
  <Button onClick={onClick} aria-label="Scroll down">
    <span></span>
  </Button>
)

export default ScrollDownButton
